<template>
  <div >
            <!-- <section>
                    <div class="px-6">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h5 class="" style="margin: 2rem; 2rem 2rem 0">{{$t('inventories')}}</h5>
                        </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center"></div>
                    </div>
                    </div>
                </section> -->

            <!-- table -->
            <section>
                <div class="">

                    <div class="row" v-if="!isDetailClient">
                        <div class="col-sm-6">
                        </div>
                        <div class="col-sm-2">
                             <!-- <select v-model="status" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;display:inline-block">
                                <option value="all">{{$t('status')}}</option>
                                <option value="all">{{$t('all')}}</option>
                                <option value="in_stock">{{$t('in_stock')}}</option>
                                <option value="out_of_stock">{{$t('out_of_stock')}}</option>
                            </select> -->
                        </div>

                        <!-- <div class="col-sm-1">
                            <button @click="generatePDF" class="flex-shrink-0 btn btn-light btn-sm align-items-center mb-3 "  style="width:100%;margin:auto;">
                                <AppIcon name="bi-cloud-arrow-down-fill" class="bi bi-cloud-arrow-down-fill" style="font-size:12px" />
                                    Pdf
                            </button>
                        </div>
                         -->
                        <div class="col-sm-2" v-if="false">
                            <date-picker :clearable="true" :editable="false" style="margin-bottom:1rem;width:100%" v-model="range" type="date" :shortcuts="shortcuts" range :placeholder="$t('select_date_range')"></date-picker>
                        </div>

                        <div class="col-sm-4">
                            <button @click="create" v-if="helper.checkAccess('create_quote') != -1" style="width:100%" class="btn btn-primary align-items-center">
                            <span class="d-inline-block me-2 .text-primary-dark">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            </span>
                            <span>{{$t('inventory')}}</span>
                        </button>
                        </div>
                    </div>

                <div class="mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6">{{$t('inventory_id')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('purchase_price')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('price')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('quantity')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('warehouse')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('status')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>

                            <tr v-for="inventory in inventories" :key="inventory.id">
                                <td class="py-5 px-6"> <router-link :to="`/inventories/${inventory.id}`">{{inventory.reference}}</router-link></td>
                                <td class="py-5 px-6">{{formatMoney(inventory.purchase_price)}}</td>
                                <td class="py-5 px-6">{{formatMoney(inventory.price)}}</td>
                                <td class="py-5 px-6" style="cursor:pointer;color:rgb(130, 127, 215)" @click="showDeliveries(inventory)">{{inventory.quantity}}</td>
                                <td class="py-5 px-6">{{inventory.warehouse ? inventory.warehouse.name : '-'}}</td>
                                 <td class="py-5 px-6">
                                    <span :class="inventory.quantity > 0 ? 'badge bg-success rounded-pill small' : 'badge bg-danger rounded-pill small'">{{inventory.quantity > 0 ? $t('in_stock') : $t('out_of_stock')}}</span>&nbsp;<span v-if="inventory.quantity > 0 && inventory.quantity < inventory.min_quantity" class="badge badge-pill bg-info">{{ $t('will_be_out_of_stock_soon') }}</span>
                                </td>
                                <td class="py-5 px-6">
                                    {{inventory.user ? inventory.user.name : '-'}}
                                    </td>
                                <td class="py-5 px-6">{{formatDate(inventory.created_at)}}</td>
                                <td class="py-5 px-6">
                                    <button @click="editRow(inventory)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button @click="deleteRow(inventory)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="loading === false && count > inventories.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getInventories" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="text-center" />
                    <div v-if="loading === false && !inventories.length" class="text-center" style="padding:1rem">{{$t('no_product_found')}}.</div>
                </div>
                </div>
            </section>
            <!-- table -->

        <!-- Create Modal -->
        <div class="modal fade" id="create-inventory-modal" tabindex="-1" aria-labelledby="create-inventory-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('add_inventory')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="createInventoryModalisOpen === true" class="modal-body" style="text-align:left">
                    <div class="row">

                        <h5>{{$t('inventory')}}</h5>
                        <div class="col-sm-2 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('purchase_price')}}</label>
                            <input v-model="inventory.purchase_price" @focus="handleInputFocus(inventory, 'purchase_price')" @blur="handleInputBlur(inventory, 'purchase_price')"  type="number" class="form-control" id="exampleFormControlInput1" placeholder="100" min="0">
                        </div>
                        <div class="col-sm-2 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                            <input v-model="inventory.price" @focus="handleInputFocus(inventory, 'price')" @blur="handleInputBlur(inventory, 'price')"  type="number" class="form-control" id="exampleFormControlInput1" placeholder="150" min="0">
                        </div>
                        <div class="col-sm-2 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('quantity')}}</label>
                            <select v-if="!inventory.custom_quantity_mode" class="form-select" :value="Number(inventory.quantity)" @change="onQuantityChange($event)">
                                <option :value="0">0</option>
                                <option :value="1">1</option>
                                <option :value="2">2</option>
                                <option :value="3">3</option>
                                <option :value="4">4</option>
                                <option :value="5">5</option>
                                <option :value="6">6</option>
                                <option :value="7">7</option>
                                <option :value="8">8</option>
                                <option :value="9">9</option>
                                <option :value="10">10</option>
                                <option value="custom">Custom</option>
                            </select>
                            <div v-else class="input-group">
                                <input v-model="inventory.quantity" @focus="handleInputFocus(inventory, 'quantity')" @blur="handleInputBlur(inventory, 'quantity')" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode()" style="padding: 0 5px;">
                                    <AppIcon name="bi-list" class="bi bi-list" />
                                </button>
                            </div>
                        </div>
                        <div class="col-sm-2 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('min_quantity')}}</label>
                            <input v-model="inventory.min_quantity" @focus="handleInputFocus(inventory, 'min_quantity')" @blur="handleInputBlur(inventory, 'min_quantity')" type="number" class="form-control" id="exampleFormControlInput1" placeholder="0" min="0">
                        </div>

                        <div class="col-sm-4 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('warehouse')}}</label>
                            <auto-complete
                            v-if="createWarehouseState === false"
                            @emitAutoCompleteWarehouse="emitAutoCompleteWarehouse"
                            :defaultValue="inventory.warehouse ? inventory.warehouse.name : '' "
                            entity="warehouses"
                            emitEvent="emitAutoCompleteWarehouse"
                        ></auto-complete>
                            <div class="related-create-link" style="padding: 5px;font-weight: bold;font-size: 12px;" @click="openCreateWarehouseModal">{{$t('create_new_warehouse')}}</div>
                        </div>

                    </div>

                        <div class="row">
                            <div class="col-sm-2 mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('unity')}}</label>
                                <input v-model="inventory.unity" type="string" class="form-control" id="exampleFormControlInput1" placeholder="L" >
                            </div>
                            <div class="col-sm-3 mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('expiration_date')}}</label>
                                <input v-model="inventory.expiration_date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="L" >
                            </div>
                        </div>

                    <div class="mb-3">
                        <collapsible-notes-field v-model="inventory.notes" id="inventory-notes" rows="1" />
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || (!inventory.purchase_price || !inventory.price || !inventory.quantity || !inventory.min_quantity ||  !inventory.product.id ) " @click="saveRow"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Create modal -->


        <div class="modal fade" id="show-deliveries" tabindex="-1" aria-labelledby="show-deliveries" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('deliveries')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>

                    <div v-if="deliveryModalisOpen === true" class="modal-body" style="text-align:left">

                        <delivery-component v-if="inventory && inventory.id" :inventory_id="inventory.id"></delivery-component>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    </div>

                </div>
            </div>
        </div>


        <!-- Edit Modal -->
        <div  class="modal fade" id="edit-inventory-modal" tabindex="-1" aria-labelledby="edit-inventory-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('edit_inventory')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="editInventoryModalisOpen === true" class="modal-body" style="text-align:left">
                <div class="row">

                <div class="col-sm-2 mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('purchase_price')}}</label>
                    <input v-model="inventory.purchase_price" @focus="handleInputFocus(inventory, 'purchase_price')" @blur="handleInputBlur(inventory, 'purchase_price')"  type="number" class="form-control" id="exampleFormControlInput1" placeholder="100">
                </div>
                <div class="col-sm-2 mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                    <input v-model="inventory.price" @focus="handleInputFocus(inventory, 'price')" @blur="handleInputBlur(inventory, 'price')" type="number" class="form-control" id="exampleFormControlInput1" placeholder="150">
                </div>
                <div class="col-sm-2 mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('quantity')}}</label>
                    <select v-if="!inventory.custom_quantity_mode" class="form-select" :value="Number(inventory.quantity)" @change="onQuantityChange($event)">
                        <option :value="0">0</option>
                        <option :value="1">1</option>
                        <option :value="2">2</option>
                        <option :value="3">3</option>
                        <option :value="4">4</option>
                        <option :value="5">5</option>
                        <option :value="6">6</option>
                        <option :value="7">7</option>
                        <option :value="8">8</option>
                        <option :value="9">9</option>
                        <option :value="10">10</option>
                        <option value="custom">Custom</option>
                    </select>
                    <div v-else class="input-group">
                        <input v-model="inventory.quantity" @focus="handleInputFocus(inventory, 'quantity')" @blur="handleInputBlur(inventory, 'quantity')" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode()" style="padding: 0 5px;">
                            <AppIcon name="bi-list" class="bi bi-list" />
                        </button>
                    </div>
                </div>
                    <div class="col-sm-2 mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('min_quantity')}}</label>
                        <input v-model="inventory.min_quantity" @focus="handleInputFocus(inventory, 'min_quantity')" @blur="handleInputBlur(inventory, 'min_quantity')" type="number" class="form-control" id="exampleFormControlInput1" placeholder="0" min="0">
                    </div>
                    <div class="col-sm-3 mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('warehouse')}}</label>
                        <auto-complete
                            v-if="createWarehouseState === false"
                            @emitAutoCompleteWarehouse="emitAutoCompleteWarehouse"
                            :defaultValue="inventory.warehouse ? inventory.warehouse.name : '' "
                            entity="warehouses"
                            emitEvent="emitAutoCompleteWarehouse"
                        ></auto-complete>

                        <div class="related-create-link" style="padding: 5px;font-weight: bold;font-size: 12px;" @click="openCreateWarehouseModal">{{$t('create_new_warehouse')}}</div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2 mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('unity')}}</label>
                        <input v-model="inventory.unity" type="string" class="form-control" id="exampleFormControlInput1" placeholder="L" >
                    </div>
                    <div class="col-sm-3 mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('expiration_date')}}</label>
                        <input v-model="inventory.expiration_date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="L" >
                    </div>
                </div>


                 <div class="mb-3">
                    <collapsible-notes-field v-model="inventory.product.notes" id="inventory-product-notes" rows="1" />
                </div>

            </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading" @click="updateRow"> <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" /> {{$t('edit')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Edit modal -->


        <div class="modal fade" id="show-upload" tabindex="-1" aria-labelledby="show-upload" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Upload Produits</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="showUploadModalisOpen === true" class="modal-body" style="text-align:left">

                <import-product></import-product>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                </div>
                </div>
            </div>
        </div>

        <div v-if="createSuplierState">
            <add-supplier :state="createSuplierState" @createSupplier="createSupplier"/>
        </div>

        <div v-if="createCategoryState">
            <add-category :state="createCategoryState" @createCategory="createCategory"/>
        </div>

        <div v-if="createWarehouseState">
            <add-warehouse :state="createWarehouseState" @createWarehouse="createWarehouse"/>
        </div>
  </div>
</template>
<script>
import helper from '../helper'
import autoComplete from './autocomplete/AutoComplete'
import DeliveryComponent from '../components/DeliveryComponent.vue'
import addWarehouse from '../components/AddWarehouse.vue'
import AddSupplier from '../components/AddSupplier.vue'
import addCategory from './AddCategory.vue'
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ImportProduct from '../components/ImportProduct.vue'

export default {
  name: 'InventoryComponent',
  persistedFilterState: {
    key: 'inventory-component',
    fields: ['search', 'status', 'range', 'start', 'end', 'per_page'],
    dateFields: ['range'],
  },
  props : ['product_id','isDetailClient'],
  components : {
    AddSupplier,
    ImportProduct,
    addCategory,
    addWarehouse,
    autoComplete,
    DeliveryComponent,
    DatePicker
  },
  data(){
    return {
        search : '',
        count : 0,
        page : 1,
        status : 'all',
        showUploadModalisOpen : false,
        inventories : [],
        categories : [],
        suppliers : [],
        inventory : {
            purchase_price : "0",
            price : "0",
            quantity : "0",
            custom_quantity_mode: false,
            min_quantity : "0",
            product : {
                label : '',
                description : '',
                barcode : '',
                supplier_id : null,
                category_id : null,
                supplier : {
                    name : ''
                },
                category : {
                    name : ''
                },
                notes : '',
            },
        },
        product : {
            label : '',
            description : '',
            barcode : '',
            supplier_id : null,
            category_id : null,
            notes : '',
            inventories : []
        },
        range: [],
        start : null,
        end : null,
        shortcuts: [
          {
            text: "Aujourd'hui",
            onClick() {
              return [moment().toDate(),moment().toDate()];
            },
          },
          {
            text: 'Hier',
            onClick() {
              return [moment().subtract(1,"days").toDate(),moment().toDate()];
            },
          },
          {
            text: 'Ce Mois',
            onClick() {
              return [moment().startOf('month').toDate(),moment().toDate()];
            },
          },
          {
            text: 'Mois Dernier',
            onClick() {
              return [moment().subtract(1,"month").startOf('month').toDate(),moment().subtract(1,"month").endOf('month').toDate()];
            },
          },
          {
            text: "Cette d'année",
            onClick() {
              return [moment().startOf("year").toDate(),moment().toDate()];
            },
          },
          {
            text: "L'année Dernier",
            onClick() {
              return [moment().subtract(1,"year").startOf('year').toDate(),moment().subtract(1,"year").endOf('year').toDate()];
            },
          }
        ],
        createModal : null,
        editModal : null,
        createInventoryModalisOpen :false,
        editInventoryModalisOpen :false,
        loading: false,
        createSuplierState : false,
        createCategoryState : false,
        createWarehouseState : false,
        per_page : 25,
        pagination : [],
        url : '',
        deliveryModalisOpen : false,
        deliveryModal : false
    }
  },
  mounted(){

    this.getInventories()

    if(this.product_id){
        this.inventory.product.id = this.product_id
    }
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('create-inventory-modal'))
    // document.getElementById('create-inventory-modal').addEventListener('hidden.bs.modal', () => { this.createInventoryModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.editInventoryModal = new bootstrap.Modal(document.getElementById('edit-inventory-modal'))
    // document.getElementById('edit-inventory-modal').addEventListener('hidden.bs.modal', () => { this.editInventoryModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.deliveryModal = new bootstrap.Modal(document.getElementById('show-deliveries'))
    // document.getElementById('show-deliveries').addEventListener('hidden.bs.modal', () => { this.deliveryModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.showUplaodModal = new bootstrap.Modal(document.getElementById('show-upload'))
    // document.getElementById('show-upload').addEventListener('hidden.bs.modal', () => { this.showUploadModalisOpen = false })

  },
  methods : {
    create(){
        this.clearForm()

        if(this.product_id){
            this.inventory.product.id = this.product_id
        }
        this.createInventoryModalisOpen = true
        // eslint-disable-next-line no-undef
        this.createModal.show()
    },
    editRow(row){
        this.editInventoryModalisOpen = true;
        this.inventory = row
        const qty = Number(this.inventory.quantity);
        if(Number.isInteger(qty) && qty >= 0 && qty <= 10) {
             this.$set(this.inventory, 'custom_quantity_mode', false)
        } else {
             this.$set(this.inventory, 'custom_quantity_mode', true)
        }
        this.editInventoryModal.show()
    },
    //crud
    async saveRow(){
        try{
            if(this.inventory.product.id == null){
                window.vueOpener.open({
                    message: 'Veuillez remplir tous les champs',
                    type: 'warning',
                    position : 'bottom'
                });
                return;
            }
            this.loading = true;
            await helper.customPost(`${process.env.VUE_APP_API}/products/${this.inventory.product.id}/inventories`,this.inventory,{showToast:true})
            this.loading = false;
            this.getInventories()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false;
        }

    },
    async updateRow(){
        try{
            this.loading = true;
            await helper.customPatch(`${process.env.VUE_APP_API}/products/${this.inventory && this.inventory.product && this.inventory.product.id ? this.inventory.product.id : null }/inventories/${this.inventory.id}`,this.inventory)
            this.loading = false;
            this.editInventoryModal.hide()
            this.getInventories()
        }catch(error){
            this.loading = false;
        }

    },
    async deleteRow(row){
            this.$swal.fire({
                title: `${this.$t('are_you_sure')}?`,
                text : this.$t('you_cant_revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/products/${row.product && row.product.id ? row.product.id : null}/inventories/${row.id}`)
                    this.inventories = helper.withoutDeletedRecords(this.inventories, row.id)
                    this.count = Math.max(0, this.count - 1)
                }
            })
    },
    clearForm(){
        this.product = {
            id : null,
            label : '',
            description : '',
            barcode : '',
            purchase_price : "0",
            price : "0",
            quantity : "0",
            custom_quantity_mode: false,
            min_quantity : "0",
            unity : null,
            expiration_date : null,
            supplier_id : null,
            category_id : null,
            notes : ''
        }
        this.inventory = {
            purchase_price : "0",
            price : "0",
            quantity : "0",
            custom_quantity_mode: false,
            min_quantity : "0",
            unity : null,
            expiration_date : null,
            product : {
                label : '',
                description : '',
                barcode : '',
                supplier_id : null,
                category_id : null,
                supplier : {
                    name : ''
                },
                category : {
                    name : ''
                },
                notes : '',
            },
        }
    },
    async getInventories(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            let url = this.start ? `${process.env.VUE_APP_API}/inventories?page=${this.page}&start=${this.start}&end=${this.end}&per_page=${this.per_page}&status=${this.status}&product_id=${this.product_id}` : `${process.env.VUE_APP_API}/inventories?page=${this.page}&per_page=${this.per_page}&status=${this.status}&product_id=${this.product_id}`
            this.inventories = []

            //check keyword
            if(this.search != ""){
                url = `${process.env.VUE_APP_API}/inventories?keyword=${this.search}&page=${this.page}&per_page=${this.per_page}`
            }

            const response = await helper.customGet(url)
            this.inventories = response.data.data
            for(let i = 0 ; i < this.inventories.length ; i++){
                if(this.inventories[i].expiration_date){
                    this.inventories[i].expiration_date = moment(this.inventories[i].expiration_date).format('YYYY-MM-DD')
                }
            }
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

             //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }

            this.loading = false
        }catch(error){
            this.loading = false
        }
    },
    async showDeliveries(row){
        this.clearForm()
        this.inventory = row
        this.deliveryModalisOpen = true
        // eslint-disable-next-line no-undef
        this.deliveryModal.show()
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    emitAutoComplete(data){
        this.inventory.product = data.result.product
    },
    emitAutoCompleteCategory(data){
        this.product.category_id = data.result.id
        this.inventory.product.category_id = data.result.id
    },
    createSupplier(data){
        if(data.supplier){
            this.product.supplier_id = data.supplier.id
            this.inventory.product.supplier_id = data.supplier.id
            this.inventory.product.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSuplierState = data.state
        }
    },
    createCategory(data){
        if(data.category){
            this.product.category_id = data.category.id
            this.inventory.product.category_id = data.category.id
            this.inventory.product.category = data.category
        }
        if(data && data.state != undefined){
            this.createCategoryState = data.state
        }
    },
    openCreateSupplierModal(){
        this.createSuplierState = !this.createSuplierState
    },
    openCreateCategoryModal(){
        this.createCategoryState = !this.createCategoryState
    },
     openCreateWarehouseModal(){
        this.createWarehouseState = !this.createWarehouseState

    },
    emitAutoCompleteWarehouse(data){
        this.product.warehouse_id = data.result.id
        this.inventory.warehouse_id = data.result.id
    },
    createWarehouse(data){
        if(data.warehouse){
            this.inventory.warehouse_id = data.warehouse.id
            this.inventory.warehouse = data.warehouse
        }
        if(data && data.state != undefined){
            this.createWarehouseState = data.state
        }
    },
    generatePDF() {
        const doc = new jsPDF();
        const data = []
        for(let i = 0 ; i < this.inventories.length ; i++){
            const inventory = this.inventories[i]

            data.push([
                inventory.product ? inventory.product.label : '-',
                `${ this.formatMoney(inventory.purchase_price)}`,
                `${ this.formatMoney(inventory.price) }`,
                inventory.product && inventory.product.supplier && inventory.product.supplier.name ? inventory.product.supplier.name : '-',
                inventory.quantity,
                inventory.quantity > 0 ? this.$t('in_stock') : this.$t('out_of_stock'),
            ])
        }
        doc.text("Inventaire", 15, 10);
        autoTable(doc, {
            head: [["Label", "Prix d'achat", "Prix de vente", "Fournisseur", "Qty", "Status"]],
            body: data
        })
        doc.save('Inventaires.pdf')
    },
    showUplaod(){
        this.showUploadModalisOpen = true;
        this.showUplaodModal.show()
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
        }
    },
    onQuantityChange(event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.inventory.custom_quantity_mode = true;
        } else {
            this.inventory.custom_quantity_mode = false;
            this.inventory.quantity = Number(val);
        }
    },
    switchToSelectMode() {
        this.inventory.custom_quantity_mode = false;
        this.inventory.quantity = 0;
    },
  },
  watch : {
    async search(){
        if(this.search.length > 2){
            this.loading = true
            this.inventories = []
            clearTimeout(this.timer_id);
            this.timer_id = setTimeout(async () => {
                const response = await helper.customGet(`${process.env.VUE_APP_API}/inventories?keyword=${this.search}&per_page=${this.per_page}`)
                this.inventories = response.data.data
                this.count = response.data.count
                this.loading = false
            }, 500);
        }
        if(this.search == '') return this.getInventories()
    },
    range(){
        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getInventories()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getInventories()
        }else{
            this.inventories = []
        }

    },
    per_page(){
        this.getInventories(this.page)
    },
    status(){
        this.getInventories()
    },
    product_id(){
        this.getInventories()
    }
  },
  computed : {
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS },
    helper(){ return helper }
  }
}
</script>


<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
